
















































































import Vue, { PropType } from 'vue';
// import { BrandData } from '@/modules/exhibitor/brand';
import {
  BrandData,
} from 'mostra';

export default Vue.extend({
  name: 'GBrandOrderForm',
  props: {
    brand: {
      type: Object as PropType<BrandData>,
      default: () => ({}),
    },
  },
});
